import { Directive, Input } from '@angular/core';
import { PerformancePieComponent } from '../components/performance-pie/performance-pie.component';
import { PieMetrics } from '../interfaces/pie-metrics.interface';

@Directive({
  selector: 'shared-performance-pie',
  standalone: false,
})
export class PieSourceMetricsDirective {
  @Input() set sourceMetrics(value: PieMetrics | null) {
    if (value == null) {
      this.host.arcs = [0, 0, 0, 0];
      return;
    }

    this.host.arcs = this.getPieDataFromMetrics(value);
  }

  constructor(private host: PerformancePieComponent) {}

  private getPieDataFromMetrics(metrics: PieMetrics): number[] {
    if (metrics == null) {
      return [0, 0, 0, 0];
    }

    const total = metrics.completed + metrics.businessException + metrics.systemException;
    if (total === 0) {
      return [0, 0, 0, 0];
    }

    const x = metrics.completed / total;
    const y = metrics.businessException / total;
    const z = metrics.systemException / total;

    return [x, y, z, 1 - x - y - z];
  }
}
